import React, { useEffect, useState, useRef } from 'react';
import { setDoc, getFirestore, collection, updateDoc, arrayUnion, doc, query, where, getDocs, getDoc } from "firebase/firestore";
import { db } from '../Firebase/Firebase';
import { getAuth } from "firebase/auth";
import Navbar from '../Components/NavBarAirbnbStyle';
import Footer from '../Components/footer';
import './PageRosania.css';
import iconPrivate from '../img/iconPrivate.png';
import iconEquipos from '../img/iconEquipos.png';
import Lateral1 from '../images/lateral1.png';
import Lateral2 from '../images/lateral2.png';

const PageRosania = () => {
    const [location, setLocation] = useState(null);
    const [idLugar, setIdLugar] = useState(null);
    const [espacios, setEspacios] = useState([]);
    const [tiposEspacio, setTiposEspacio] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [numberOfSlidesToShow, setNumberOfSlidesToShow] = React.useState(3);

    useEffect(() => {
        const savedLocation = sessionStorage.getItem('selectedLocation');
        if (savedLocation) {
            const parsedLocation = JSON.parse(savedLocation);
            setLocation(parsedLocation);
            setIdLugar(parsedLocation.id);
        }
    }, []);

    const fetchEspacios = async () => {
        if (idLugar) {
            const espaciosCollection = collection(db, 'espacios');
            const q = query(espaciosCollection, where('IdLugar', '==', idLugar));
            const querySnapshot = await getDocs(q);

            const espaciosData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));
            setEspacios(espaciosData);
        }
        setLoading(false);
    };

    const fetchTiposEspacio = async () => {
        const tiposEspacioCollection = collection(db, 'tipoespacio');
        const querySnapshot = await getDocs(tiposEspacioCollection);

        const tiposEspacioData = {};
        querySnapshot.forEach((doc) => {
            tiposEspacioData[doc.id] = {
                tipo: doc.data().TipoEspacio,
                icono: doc.data().icono,
                color: doc.data().color,  // Asegúrate de que el campo `Color` exista en tu base de datos
            };
        });

        setTiposEspacio(tiposEspacioData);
    };

    useEffect(() => {
        fetchEspacios();
        fetchTiposEspacio();
    }, [idLugar]);


    // Función para obtener los datos del tipo de espacio
    const obtenerTipoEspacio = async (tipoEspacioId) => {
        const tipoEspacioDocRef = doc(db, 'tipoespacio', tipoEspacioId); // Referencia al documento en la colección 'tipoespacio'
        const tipoEspacioDoc = await getDoc(tipoEspacioDocRef);

        if (tipoEspacioDoc.exists()) {
            return tipoEspacioDoc.data(); // Retorna los datos del tipo de espacio
        } else {
            console.error("TipoEspacio no encontrado");
            return null;
        }
    };

    // Función para generar un ID único para invitados
    const generateGuestId = () => {
        return `Invitado_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
    };

    // Función para obtener o generar un ID único para invitados
    const getGuestId = () => {
        const guestIdKey = "guestId";
        let guestId = sessionStorage.getItem(guestIdKey);
        if (!guestId) {
            guestId = generateGuestId();
            sessionStorage.setItem(guestIdKey, guestId);
        }
        return guestId;
    };

    const registrarClicEspacio = async (idEspacio, nombreEspacio, tipoEspacioId) => {
        const auth = getAuth();
        const user = auth.currentUser;

        // Manejar datos del usuario, ya sea autenticado o como "Invitado"
        const nombreUsuario = user?.displayName || "Invitado";
        const [nombre, apellido = ""] = nombreUsuario.split(" ");
        const email = user?.email || "Sin email";
        const userId = user?.uid || getGuestId(); // Reutilizar ID único para invitados

        // Referencia al documento del usuario en Firestore
        const userDocRef = doc(db, "Interacciones", userId);

        // Obtener datos del tipo de espacio utilizando el ID de tipoEspacio
        const tipoEspacio = await obtenerTipoEspacio(tipoEspacioId); // Obtener los datos del tipo de espacio

        if (!tipoEspacio) {
            console.error("No se pudo obtener el tipo de espacio.");
            return;
        }

        const datosClic = {
            idEspacio,
            nombreEspacio,
            tipoEspacio: tipoEspacio.TipoEspacio, // Utilizar el valor obtenido de 'tipoespacio'
            contador: 1, // Inicia con 1 en el primer registro
            fechaHora: new Date(), // Agregar fecha y hora actual
        };

        try {
            // Verificar si el documento del usuario ya existe
            const userDoc = await getDoc(userDocRef);
            if (!userDoc.exists()) {
                // Si no existe, crear un documento para el usuario
                await setDoc(userDocRef, {
                    nombre,
                    apellido,
                    email,
                    clics: {}, // Inicializar el mapa de clics
                });
            }

            // Obtener los clics existentes
            const userData = userDoc.exists() ? userDoc.data() : {};
            const clicsExistentes = userData.clics?.Espacios || [];

            // Buscar si ya existe un registro para el espacio actual
            const clicExistente = clicsExistentes.find(clic => clic.idEspacio === idEspacio);

            if (clicExistente) {
                // Incrementar el contador del espacio existente
                clicExistente.contador += 1;
                clicExistente.fechaHora = new Date(); // Actualizar la fecha y hora del clic

                // Actualizar solo el clic modificado
                const clicsActualizados = clicsExistentes.map(clic =>
                    clic.idEspacio === idEspacio ? clicExistente : clic
                );

                // Actualizar el documento en Firestore
                await updateDoc(userDocRef, {
                    [`clics.Espacios`]: clicsActualizados,
                });
            } else {
                // Solo agregar el clic si no existe en el array
                await updateDoc(userDocRef, {
                    [`clics.Espacios`]: arrayUnion(datosClic),
                });
            }

            console.log(`Clic registrado en la sección "Espacios" para el usuario:`, datosClic);
        } catch (error) {
            console.error("Error al registrar clic en Espacios:", error);
        }
    };

    // Función que se llama cuando se hace clic en el botón "Confirmar reserva"
    const handleConfirmarReservaClick = async (espacio) => {
        // Extraer los datos del espacio
        const { IdEspacio, NombreEspacio, TipoEspacio } = espacio;

        // Llamar a la función de registro de clic
        await registrarClicEspacio(IdEspacio, NombreEspacio, TipoEspacio); // Esperar que se registre el clic

        // Redirigir a la página de confirmación de reserva después de registrar el clic
        window.location.href = '/Office/' + IdEspacio;
    };


    const slides = espacios.map((espacio) => {
        const tipoEspacio = tiposEspacio[espacio.TipoEspacio] || {};

        return {
            image: espacio.Imagenes && espacio.Imagenes.length > 0 ? espacio.Imagenes[0] : '/ruta/a/imagen/por_defecto.png',
            name: espacio.NombreEspacio || 'Espacio Sin Nombre',
            type: tipoEspacio.tipo || 'Tipo Sin Nombre',
            icon: tipoEspacio.icono || iconPrivate,
            infoLink: '/Office/' + espacio.IdEspacio,
            buttonAction: () => handleConfirmarReservaClick(espacio), // Acción del botón
        };
    }).filter(slide => slide.image !== '/ruta/a/imagen/por_defecto.png');

    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 800);

    const nextSlide = () => {
        setCurrentSlide((prevIndex) => (prevIndex + 1) % slides.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
    };

    useEffect(() => {
        const updateSlidesToShow = () => {
            if (window.innerWidth < 1025) {
                setNumberOfSlidesToShow(1);
            } else if (window.innerWidth < 1386) {
                setNumberOfSlidesToShow(2);
            } else {
                setNumberOfSlidesToShow(3);
            }
        };

        window.addEventListener('resize', updateSlidesToShow);
        updateSlidesToShow(); // Ejecuta una vez al cargar el componente

        return () => window.removeEventListener('resize', updateSlidesToShow);
    }, []);

    const getVisibleSlides = () => {
        const visibleSlides = [];
        for (let i = 0; i < numberOfSlidesToShow; i++) {
            const slideIndex = (currentSlide + i) % slides.length;
            if (slides[slideIndex]) {
                visibleSlides.push(slides[slideIndex]);
            }
        }
        return visibleSlides;
    };




    const [showAllSpace, setShowAllSpace] = useState(false); // Estado para alternar visibilidad y texto
    const allSpaceRef = useRef(null);

    const handleToggleAllSpaces = () => {
        setShowAllSpace(!showAllSpace); // Alterna entre mostrar y ocultar el contenedor
        if (!showAllSpace) {
            // Hace scroll al inicio del contenedor cuando se muestra
            setTimeout(() => {
                allSpaceRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100); // Añade un pequeño retraso para asegurarse de que el contenedor está visible
        }
    };
    return (
        <div>
            <Navbar />
            <div className="ofmas-container-Rosania">
                <div>
                    <h2 className="card-title-office-rosania">
                        Rosania Business Center
                    </h2>
                </div>
                <div>
                    {loading ? (
                        <p>Cargando espacios...</p>
                    ) : (
                        <div className="gridmar-rosania">
                            <button className="prev-btn-rosania" onClick={prevSlide}>❮</button>

                            {getVisibleSlides().map((slide, index) => (
                                <div key={index} className={'cardmar-rosania'}>
                                    <div className="content-container-rosania">
                                        <img src={slide.image} alt={slide.name} className="item-image-Rosania" />
                                        <div className="item-info">
                                            <h3 className="item-name-rosania">{slide.type}</h3>
                                            <img src={slide.icon} alt={slide.name} className="icon-Rosania" />

                                            <div>
                                                <button
                                                    onClick={slide.buttonAction} // Registrar clic y redirigir
                                                    className="btn-rosania-grid"
                                                >
                                                    Confirmar reserva
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <button className="next-btn-rosania" onClick={nextSlide}>❯</button>
                        </div>
                    )}
                </div>



                <button className='btn-AllSpace' onClick={handleToggleAllSpaces}>
                    {showAllSpace ? 'Menos espacios' : 'Todos los espacios'}
                </button>
            </div>
            <br></br><br></br><br></br>
            {showAllSpace && ( // Muestra solo si showAllSpace es true
                <div className='container-allSpace' ref={allSpaceRef}>
                    <div className='ofmas-title'>
                        <h2 className='title-allSpace'>Rosania Business Center</h2>
                    </div>


                    {loading ? (
                        <p>Cargando espacios...</p>
                    ) : (
                        <div className="allSpace-grid-container">
                            {espacios.map((espacio, index) => {
                                // Determinar la clase a aplicar según el índice
                                const tipoEspacio = tiposEspacio[espacio.TipoEspacio] || {};

                                return (
                                    <div key={index}>
                                        <div className="allSpace-inner-grid"
                                            style={{
                                                padding: '10px',
                                                borderRadius: '30px',
                                                border: `solid 3.5px ${tipoEspacio.color || 'orange'}`,
                                            }}                                         >
                                            <div className="allSpace-inner-item">
                                                <img
                                                    src={espacio.Imagenes && espacio.Imagenes.length > 0 ? espacio.Imagenes[0] : '/ruta/a/imagen/por_defecto.png'}
                                                    alt={espacio.NombreEspacio || 'Espacio Sin Nombre'}
                                                    className="item-image-Rosania"
                                                />
                                            </div>
                                            <div className="allSpace-inner-item">
                                                <div className="title-allSpaces">
                                                    {tipoEspacio.tipo || 'Tipo Sin Nombre'}
                                                </div>
                                                <div className="allSpace-inner-item">
                                                    <img
                                                        src={tipoEspacio.icono || '/ruta/a/icono/por_defecto.png'}
                                                        alt={`Icono de ${espacio.NombreEspacio}`}
                                                        className="icon-Rosania2"
                                                    />
                                                </div>
                                                <button
                                                    onClick={() => window.location.href = '/Office/' + espacio.IdEspacio}
                                                    className="btn-rosania-grid"
                                                >
                                                    Confirmar reserva
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                    )}

                </div>

            )}


        </div>
    );
};

export default PageRosania;
